var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlinePlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.22 12c0-5.93 4.83-10.75 10.75-10.75S22.72 6.07 22.72 12 17.9 22.75 11.97 22.75C6.05 22.75 1.22 17.93 1.22 12zm1.5 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25-4.15-9.25-9.25-9.25S2.72 6.9 2.72 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33 16.67c-.86-.5-1.34-1.48-1.34-2.76v-3.35c0-1.28.47-2.26 1.33-2.76.86-.5 1.95-.42 3.06.22l2.9 1.67c1.11.64 1.72 1.54 1.72 2.54 0 .99-.61 1.9-1.72 2.54l-2.9 1.67c-.62.37-1.25.55-1.82.55-.44 0-.86-.11-1.23-.32zm.75-7.58c-.38.22-.59.75-.59 1.47v3.35c0 .71.21 1.25.59 1.46.37.22.94.13 1.56-.22l2.9-1.67c.62-.36.97-.81.97-1.24 0-.43-.36-.88-.97-1.24l-2.9-1.67c-.4-.24-.77-.36-1.08-.36-.18 0-.35.04-.48.12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlinePlayCircle);
export default __webpack_public_path__ + "static/media/vuesax-outline-play-circle.2e4876a52b0bfe0ae92a519b1d44f529.svg";
export { ForwardRef as ReactComponent };